import * as React from 'react'

import { cn } from 'src/shared/utils/cn'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hidePlaceholderOnFocus?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hidePlaceholderOnFocus, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'focus-visible:border-1 flex h-14 w-full rounded-md border bg-background px-3 py-3.5 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted focus:placeholder:text-primary focus-visible:border-primary focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
          hidePlaceholderOnFocus && 'focus:placeholder:text-transparent',
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
